import React, {useEffect} from "react";
import {connect} from "react-redux";
import {Col, Row} from "reactstrap";


// components
import AirportList from "./_list";
import AirportForm from "./_form";
import {showLoader} from "../../../components/loader/loader";
import {ButtonNew} from "../../../components/buttons/buttonsActions";
import {ModalFormContainer} from "../../../components/confirmAlert/ModalFormContainer";


// actions
import {clearState, setApp} from "../../../redux/actions/generalActions/mainActions";
import {clearState as clearListState} from "../../../redux/actions/generalActions/listActions";
import {setForm} from "../../../redux/actions/generalActions/formActions";




const Airport = (props) => {
    const { loading } = props.mainProps

    useEffect(() => {
        return () => {
            props.clearState();
            props.clearListState();
        }
    }, []);

    useEffect(() => {
        if (props.app !== null)
            props.setApp(props.app);
    },[ ]);


    const createItem = () => {
        props.setForm();
        ModalFormContainer(AirportForm);
    }


    return <>
        {loading && showLoader()}

        <Row>
            <Col md="12">
                <div className="d-flex align-items-center">
                    <div className="ml-auto paddingAdd">
                        <ButtonNew onClick={createItem}/>
                    </div>
                </div>
            </Col>
        </Row>

        <AirportList />
    </>
}

const mapStateToProps = state => ({
    mainProps: state.mainProps,
    formProps: state.formProps,
})

const mapActionsToProps = ({
    setForm,
    setApp,
    clearState,
    clearListState,
});

export default connect(mapStateToProps, mapActionsToProps)(Airport);